import { render, staticRenderFns } from "./EmergencyNumberForm.vue?vue&type=template&id=24f8ca10&"
import script from "./EmergencyNumberForm.vue?vue&type=script&lang=js&"
export * from "./EmergencyNumberForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports